module.exports = __webpack_public_path__ + "static/media/amzbootcamp.a74bfaba.svg";